import React from 'react';
import '../main.css';
import coverImage from '../cover.jpeg';
import cover2 from '../images/cover2.jpeg';

function PrimaryHome() {
  const bannerStyle = {
    width: '100%',
    height: '600px',
    backgroundImage: `url(${coverImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
    backgroundRepeat: 'no-repeat',
  };

  const contentWrapperStyle = {
    backgroundColor: '#e6f0ff', // Light blue background
    padding: '40px 0',
  };

  const contentStyle = {
    maxWidth: '1200px',
    width: '90%',
    margin: '0 auto',
    padding: '10px 15px',
  };

  const rowStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '3rem',
    alignItems: 'center',
    gap: '2rem',
  };

  const imageStyle = {
    flex: '1 1 400px',
    maxWidth: '500px',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  };

  const textStyle = {
    flex: '1 1 400px',
  };

  return (
    <>
      <div style={bannerStyle}></div>

      <div style={contentWrapperStyle}>
        <div style={contentStyle}>
          <h1 style={{ marginTop: 0, paddingTop: 0, marginBottom: '1rem' }}>
            WELCOME TO HIGHLANDS COLLEGE!
          </h1>

          <p>
            At Highlands Primary School, we believe in helping every child grow, learn, and shine.
            Our caring and friendly school is a place where children feel safe, supported, and excited to discover new things every day.
            We encourage our students to be curious, kind, and confident, while learning the important skills they need for the future.
            With dedicated teachers, fun learning activities, and a strong sense of community, we work together to help every child become the best they can be — at school and beyond.
          </p>

          <div style={rowStyle}>
            <img src={cover2} alt="Primary School Environment" style={imageStyle} />
            <div style={textStyle}>
              <h3>CHOOSE THE BEST FOR YOUR CHILD!!</h3>
              <p>
                Highlands is more than just a school — it’s a nurturing space where values meet excellence.
                Your child will grow in a balanced environment that encourages:
              </p>
              <ul>
                <li><strong>Strong academics</strong> that develop critical thinking and creativity</li>
                <li><strong>Solid values</strong> that foster kindness, leadership, and confidence</li>
                <li><strong>Active sports programs</strong> to keep the body healthy and the spirit motivated</li>
              </ul>
              <p>
                With small class sizes, dedicated teachers, and vibrant facilities, Highlands ensures your child receives
                the personalized attention and holistic growth they deserve. This is the right foundation for a bright, responsible future.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrimaryHome;
